import turfUnion from "@turf/union";
import { geometryCollection } from "@turf/helpers";
import { useZoneStore } from "~/stores/zone";

export function useGetLatLngForZone() {
  const zoneStore = useZoneStore();

  const getLatLngForZone = (zone) => {
    if (!zone.subcounties.length) {
      return null;
    }

    const subcountyIds = zone.subcounties.map((s) => s.id);
    const subcountyGeoJsons = zoneStore.subcounties
      .filter(({ id }) => subcountyIds.includes(id))
      .map(({ geometryGeoJson }) => geometryGeoJson);

    let geoJson = {
      type: "Polygon",
      coordinates: [],
    };
    let latLng = [];

    if (subcountyGeoJsons.length === 1) {
      geoJson = subcountyGeoJsons[0];
    } else if (subcountyGeoJsons.length > 1) {
      geoJson = turfUnion(geometryCollection(subcountyGeoJsons)).geometry;
    }

    if (geoJson.type === "Polygon") {
      latLng = geoJson.coordinates[0].map((coordinate) => [
        coordinate[1],
        coordinate[0],
      ]);
    }

    if (geoJson.type === "MultiPolygon") {
      latLng = geoJson.coordinates.map((coords) =>
        coords[0].map((coordinate) => [coordinate[1], coordinate[0]])
      );
    }

    return latLng;
  };

  return {
    getLatLngForZone,
  };
}
